import React from 'react';
import { object, bool } from 'prop-types';

import Button from './Button';
import Text from './Text';

import { styToggleBtn } from './style';

const Toggle = ({ left, right, isRight }) => (
  <div className={styToggleBtn}>
    <div>
      <Button variant={left.variant} onClick={left.onClick} size="sm" data-testid="toggleLeft">
        <Text>{left.text}</Text>
      </Button>
    </div>
    {isRight && (
    <div style={{ marginLeft: 4 }}>
      <Button variant={right.variant} onClick={right.onClick} size="sm" data-testid="toggleRight">
        <Text>{right.text}</Text>
      </Button>
    </div>
      )}
  </div>
  );

Toggle.propTypes = {
  left: object,
  right: object,
  isRight: bool,
};

Toggle.defaultProps = {
  left: {},
  right: {},
  isRight: false,
};

export default Toggle;
